import { actionCreators } from './action';
import { connect } from 'react-redux';
import Page from './../../common/Page';

const mapStateToProps = (state) => { 
    const pageData = state.privacy && state.privacy
    return ({ pageData })   
}

function mapDispatchToProps(dispatch) {
    const callToData = () => dispatch(actionCreators.getPrivacy());
    return ({ callToData });
}

export default connect(mapStateToProps, mapDispatchToProps)(Page);
